import interceptorAxios from './InterceptorAxios';
const ServicioArchivos = {

    descargaArchivo(url, datos) {
        let mensaje = null;
        let request = {
            method: 'post',
            url: url,
            data: datos,
            responseType: 'arraybuffer'
        }
        return interceptorAxios(request).then((response) => {
            if (response.status !== 200) {
                mensaje = "Error de comunicación ";
                return mensaje;
            }
            else {

                let headers = response.headers;
                let contentType = headers['content-type'];

                if(contentType.includes('application/json'))
                    return mensaje=headers['mensaje'];

                let encabezadoContent = headers['content-disposition'];
                let result = encabezadoContent.split(';')[1].trim().split('=')[1];
                let fileName = result.replace(/"/g, '');
                let a = document.createElement("a");
                
                let tipo = this.elegirTipo(contentType);
                document.body.appendChild(a);
                let file = new Blob([response.data], {
                    type: tipo
                });
                let fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                mensaje = "si";
                return mensaje;
            }
        }).catch((error) => {
            mensaje = "Error, no le logró descargar el archivo";
            return mensaje;
        });
    },

    elegirTipo(contentType) {
        let respuesta = "";
        switch (contentType) {
            case 'application/vnd.ms-excel':
                respuesta = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;

            case 'application/pdf':
                respuesta = contentType;
                break;

            case 'application/xml':
                respuesta = contentType;
                break;

            default:
                respuesta = "";
        }
        return respuesta;
    }
    ,
    obtenerBytesBase64StringArchivo(archivo, objeto, propiedad) {
        var reader = new FileReader();
        reader.readAsBinaryString(archivo);
        reader.onload = function () {
            var arrayBuffer = this.result;
            var base64Data = btoa(arrayBuffer);
            objeto[propiedad] = base64Data;
        };
    },
    descargaArchivoComoBlob(url, datos) {      
        const request = {
            method: 'post',
            url: url,
            data: datos,
            responseType: 'arraybuffer'
        }

        return new Promise((resolve, reject) => {
              interceptorAxios(request).then((response) => {
                if (response.status !== 200) {
                    let mensaje = "Error de comunicación ";
                    reject(mensaje);
                }
                else {
                    let headers = response.headers;
                    let contentType = headers['content-type'];
                    if(contentType.includes('application/json'))
                       reject(headers['mensaje']);                   
                    let encabezadoContent = headers['content-disposition'];
                    let result = encabezadoContent.split(';')[1].trim().split('=')[1];
                    let fileName = result.replace(/"/g, '');
                    let a = document.createElement("a");
                    
                    let tipo = this.elegirTipo(contentType);
                    document.body.appendChild(a);
                    let file = new Blob([response.data], {
                        type: tipo
                    });
                    let fileURL = window.URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = fileName;
                    //a.click();
                    resolve(file);               
                }
            }).catch((error) => {
               reject(error);
            });
        });
        
    }

    
}

export default ServicioArchivos;